import {
  GAME_ID,
  UPDATE_GAME_PRACTICE_DETAILS,
  UPDATE_GAME_ONBOARDING_DETAILS,
} from '../data/goblinGourmetConstants';

const initialState = {
  highestLevelEarned: 0,
  isOnboardingCompleted: false,
};

const goblinGourmetGameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case UPDATE_GAME_PRACTICE_DETAILS: {
      const { highestLevelEarned } = payload;

      return {
        ...state,
        highestLevelEarned,
      };
    }
    case UPDATE_GAME_ONBOARDING_DETAILS: {
      return {
        ...state,
        isOnboardingCompleted: true,
      };
    }
    default:
      return state;
  }
};

export default goblinGourmetGameDetailsReducer;
